import { apiService } from "@/services/apiService";
import type { User } from "@repo/types";
import { Button } from "@repo/ui/components/Base/Button";
import { DatePicker } from "@repo/ui/components/Base/DatePicker";
import { Spinner } from "@repo/ui/components/Base/Spinner";
import { useState } from "react";

export interface DocumentSignScheduledNotifierProps {
  tenantId: string;
  documentId: string;
  initialExpirationDate: Date | null;
  user?: User | null;
  onSaved?: () => void;
}

export const DocumentSignScheduledNotifier = ({
  tenantId,
  documentId,
  initialExpirationDate,
  user,
  onSaved,
}: DocumentSignScheduledNotifierProps) => {
  const [expirationDate, setExpirationDate] = useState<Date | null>(
    initialExpirationDate
  );
  const [scheduleSaveLoading, setScheduleSaveLoading] = useState(false);

  const saveExpirationDate = async () => {
    if (!tenantId || !documentId) return;

    setScheduleSaveLoading(true);
    await apiService.v1.setSignRequestExpirationDate(tenantId, documentId, {
      expirationDate,
    });
    setScheduleSaveLoading(false);

    onSaved?.();
  };

  return (
    <div className="flex flex-col gap-2">
      <p className="font-bold">Document Signatures Reminder</p>

      <p>
        If not all signees have responded by this date, the following user will
        receive a notification email:
      </p>

      <p className="italic">
        {user
          ? `${user.firstName} ${user.lastName} (${user.email})`
          : "(Name is loading...)"}
      </p>

      <DatePicker
        date={expirationDate || undefined}
        id="expirationDate"
        onDateChange={(date) => setExpirationDate(date || null)}
      />

      <div className="flex gap-2 justify-end">
        <Button onClick={() => setExpirationDate(null)}>Clear</Button>
        <Button
          onClick={saveExpirationDate}
          disabled={
            scheduleSaveLoading ||
            expirationDate?.toString() === initialExpirationDate?.toString()
          }
        >
          {scheduleSaveLoading && (
            <Spinner className="w-5 h-5 -ml-1 mr-2 text-white" />
          )}{" "}
          Save
        </Button>
      </div>
    </div>
  );
};
